import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 2,
        mt: 'auto',
        textAlign: 'center',
        backgroundColor: '#e8edf2',
        color: 'black',
      }}
    >
      <Typography variant="body2">© 2024 Metro Fresh. All rights reserved.</Typography>
    </Box>
  );
};

export default Footer;
